import Keycloak from "keycloak-js";
import { instance } from "@/api";

export const initOptions = {
  url: import.meta.env.VITE_KEYCLOAK_IDP,
  realm: import.meta.env.VITE_REALM_NAME,
  clientId: import.meta.env.VITE_CLIENT_ID,
};
// https://keycloak.discourse.group/t/keycloak-direct-reset-password-url/17690
export const createPasswordResetLink = (redirectUri) =>
  [
    // Create url
    [initOptions.url, "realms", initOptions.realm].join("/"),
    // Create query
    Object.entries({
      redirect_uri: encodeURIComponent(redirectUri),
      response_type: "code",
      scope: "openid",
      kc_action: "UPDATE_PASSWORD",
    })
      .map((arr) => arr.join("="))
      .join("&"),
      // Merge them
  ].join("?");

export const parseJwt = (token) => {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
};

export const keycloak = new Keycloak(initOptions);

/**
 * Starts a Keycloak authorization-code login with a redirect URI that is
 * guaranteed to be free of any URL fragment.
 *
 * Why this exists: the app boots with `init({ onLoad: "check-sso" })` and no
 * `silentCheckSsoRedirectUri`, so an unauthenticated boot performs a top-level
 * `prompt=none` probe that leaves a stale `#error=login_required&state=...`
 * fragment in the address bar. A bare `keycloak.login()` defaults its
 * `redirect_uri` to `window.location.href`, which still carries that stale
 * fragment; Keycloak then appends the fresh `&code=...` response AFTER it, and
 * on the way back keycloak-js parses the stale `error` first and discards the
 * valid code (authenticated stays false). Forcing a fragment-free redirect URI
 * means the return URL holds only the fresh auth response. (HDACC-270 / PILLARS-2862)
 */
export const login = (options = {}) => {
  const cleanRedirectUri =
    window.location.origin + window.location.pathname + window.location.search;
  return keycloak.login({ redirectUri: cleanRedirectUri, ...options });
};
